import React from 'react';
import { Download } from 'lucide-react';
import { motion } from 'framer-motion';
export function Nav() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10" data-id="element-127">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-128">
        <div className="flex items-center gap-2" data-id="element-129">
          <span className="text-2xl font-black tracking-tighter text-white" data-id="element-130">
            TATAN
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-400" data-id="element-131">
          <a href="#features" className="hover:text-white transition-colors" data-id="element-132">
            Features
          </a>
          <a href="#gallery" className="hover:text-white transition-colors" data-id="element-133">
            Gallery
          </a>
          <a href="#faq" className="hover:text-white transition-colors" data-id="element-134">
            FAQ
          </a>
        </div>

        <a href="https://apps.apple.com/us/app/tatan-ai-tattoo-design-maker/id6763227385" target="_blank" rel="noopener noreferrer" className="bg-tatan-blue hover:bg-blue-500 text-white px-5 py-2.5 rounded-full font-semibold text-sm flex items-center gap-2 transition-all hover:scale-105 active:scale-95" data-id="element-135">
          <Download className="w-4 h-4" data-id="element-136" />
          <span className="hidden sm:inline" data-id="element-137">Download</span>
        </a>
      </div>
    </motion.nav>;
}